import React from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import ITInfrastructureHead from "../layout/itinfrastructure/itinfrastructure-head";
import ITInfrastructureContent from "../layout/itinfrastructure/itinfrastructure-content";


function ITInfrastructure() {
    return (
        <div>
            <Header />
            <br />
            <ITInfrastructureHead></ITInfrastructureHead>
            <br />
          <ITInfrastructureContent></ITInfrastructureContent>
            <br />
            <Footer />
        </div>
    );
}

export default ITInfrastructure